import { useState, useEffect } from 'react';
import { Menu, Bell, BookOpen } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { useUIStore } from '../../stores/uiStore';
import { USER_TYPES } from '../../utils/constants';
import { getDocsUrl } from '../../utils/docsUrl';
import { alertsService } from '../../services';
import TenantSelector from '../common/TenantSelector';
import UserProfileDropdown from '../common/UserProfileDropdown';

const Header = () => {
  const { user } = useAuthStore();
  const { toggleSidebar } = useUIStore();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    const fetchCount = async () => {
      try {
        const count = await alertsService.getUnreadCount();
        setUnreadCount(count);
      } catch {
        // Silently fail — badge just won't show
      }
    };

    fetchCount();
    const interval = setInterval(fetchCount, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <header className="bg-white border-b border-gray-200 h-16 flex items-center justify-between px-6 flex-shrink-0">
      <div className="flex items-center space-x-4">
        <button
          onClick={toggleSidebar}
          className="icon-button"
          aria-label="Toggle sidebar"
        >
          <Menu className="w-5 h-5 text-secondary-600" />
        </button>

        {/* Scope picker — for the user types with no tenant of their own */}
        {(user?.type === USER_TYPES.SUPER_ADMIN || user?.type === USER_TYPES.CHANNEL_ADMIN) && (
          <TenantSelector />
        )}
      </div>

      <div className="flex items-center space-x-3">
        {/* Documentation */}
        <button
          onClick={() => window.open(getDocsUrl(pathname), '_blank', 'noopener,noreferrer')}
          className="icon-button"
          aria-label="Documentation"
          title="Documentation"
        >
          <BookOpen className="w-5 h-5 text-secondary-600" />
        </button>

        {/* Notifications */}
        <button
          onClick={() => navigate('/notifications')}
          className="icon-button relative"
          aria-label="Notifications"
        >
          <Bell className="w-5 h-5 text-secondary-600" />
          {unreadCount > 0 && (
            <span className="notification-badge">{unreadCount > 99 ? '99+' : unreadCount}</span>
          )}
        </button>

        {/* User Profile Dropdown */}
        <UserProfileDropdown />
      </div>
    </header>
  );
};

export default Header;
